<script>
import metaInfo from '@/modules/mixins/metaInfo'
import AllowanceBlock from '@/components/organism/block/AllowanceBlock'
import NoResult from '@/components/molecules/NoResult'
export default {
    name: 'Allowances',
    components: { NoResult, AllowanceBlock },
    mixins: [metaInfo],
    computed: {
        pageTitle() {
            return this.$t('profile.pages.expense_rules')
        },
        loaded() {
            return this.$store.getters['expenseRulesLoaded']
        },
        allowances() {
            return this.$store.getters['expenseRules']
        },
        adminName() {
            return this.$user.model.company.administrator_name
        },
        adminPhone() {
            return this.$user.model.company.administrator_phone
                ? `(${this.$user.model.company.administrator_phone})`
                : ''
        },
    },
    // beforeRouteEnter(to, from, next) {
    //
    // }
}
</script>

<template lang="pug">
.profile-allowances
    h2 {{ $t('profile.expense_rules') }}
    allowance-block.mb-5(v-for="(allowance, index) in allowances" :data-index="index" :model="allowance" :key="`allowanceBlock-${index}`")
    p.body-sm(v-if="$user.model.company && loaded" :data-index="allowances.length" :key="`allowanceBlock-${allowances.length}`")
        span.font-weight-semibold {{$t('profile.need_help')}}
        br
        template(v-if="$user.model.company.administrator_name") {{$t('profile.contact_help', {name: adminName, phone: adminPhone})}}
    no-result(v-if="!allowances.length" :loading="!loaded") {{ $t('profile.no_expense_rules') }}
</template>
